// mui 5
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";

export const StyledContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginTop: theme.spacing(10),

}));
